module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANJJREFUSEvtlT0KAjEQhd9gIYiFjSewtFAr8RhewWKLPHIAC/EMsqRJ64HWQs9hJ1oskRWzBgUhkgWLTTszH+S9+RGSRwBjpH0nIVkAmKbl4iCJgTWuBX+XIsuynrX2UmVprSdlWc4ivfg0j+QSgDXGDCsYyTOAQST4WpunlOqLyA7AqoIYYx4xkmsA8xiwc67wxQsAewAjD/DgGGCYK0qprYhsAHTCwP+Cnzqml8J/vxHzQm2Tt1sI11p38zy/JR2QX9vrva7dbq/t1thpauqY3gECnVEnHUVlZAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/zhan.png
// module id = Zj8t
// module chunks = 36